module.exports = __webpack_public_path__ + "static/media/Icon_14.4818e449.svg";